import { z } from 'zod';
import { isoDateTime } from './common';

/**
 * reservations/{id} — a pre-registration / "reserve your place" request for a
 * formation whose dates are NOT yet confirmed (no open/soldout édition). Lighter
 * than an inscription: no session, no payment — just interest capture so the
 * admin can contact the person once dates are set. Distinct collection so it
 * never pollutes the real inscriptions / participant counts.
 */
export const reservationStatusSchema = z.enum(['pending', 'contacted', 'converted', 'cancelled']);
export type ReservationStatus = z.infer<typeof reservationStatusSchema>;

export const reservationProfileSchema = z.object({
  firstName: z.string().min(1).max(80),
  lastName: z.string().min(1).max(80),
  email: z.string().email(),
  phone: z.string().min(6).max(30),
});
export type ReservationProfile = z.infer<typeof reservationProfileSchema>;

export const reservationCreateSchema = z.object({
  formationId: z.string().min(1),
  profile: reservationProfileSchema,
  message: z.string().max(1000).optional(),
});
export type ReservationCreate = z.infer<typeof reservationCreateSchema>;

export const reservationSchema = reservationCreateSchema.extend({
  id: z.string(),
  status: reservationStatusSchema,
  createdAt: isoDateTime,
  updatedAt: isoDateTime,
});
export type Reservation = z.infer<typeof reservationSchema>;
